import * as React from 'react';
import { FormattedHTMLMessage, injectIntl, InjectedIntl } from 'react-intl';

import {
    VerificationService, SuccessResponse,
    CopyToClipboard,
    FormFooterComponent as FormFooter,
} from '@sheerid/jslib';

import { LogoComponent } from '../LogoComponent/LogoComponent';

interface StepSuccessProps {
    verificationService: VerificationService;
    intl: InjectedIntl;
}

const redirect = (redirectDestination: string) => {
    const win = window.open(redirectDestination, '_parent');
    win.focus();
};

const StepSuccess = ({ verificationService, intl }: StepSuccessProps) => {
    const redirectDestination = intl.messages['step.success.redirectUrl'];
    const rewardCode = (verificationService.verificationResponse as SuccessResponse).rewardCode || '${rewardCode}';

    return (
        <div id="sid-step-success" className="sid-l-container">
            <div className="sid-header sid-l-horz-center sid-l-space-top-md">
                <div className="sid-l-horz-center">
                    <LogoComponent verificationService={verificationService} />
                </div>
                <div className="sid-l-space-top-lg"></div>
                <div className="sid-header__title sid-l-horz-left sid-l-space-top-lg">
                    <FormattedHTMLMessage id="step.success.title" defaultMessage="Success!<br><br> You've been verified." />
                </div>
                <div className="sid-l-horz-left sid-l-space-top-md">
                    <FormattedHTMLMessage id="step.success.subtitle" defaultMessage="Here is your personal promo code. <br>It is unique to you and can only be used once." />
                </div>
            </div>

            <div className="sid-reward-code sid-l-space-top-md sid-field__label sid-l-horz-left">
                {rewardCode}
            </div>

            <div className="sid-l-horz-left">
                <CopyToClipboard
                    textToCopy={rewardCode}
                >
                    <FormattedHTMLMessage id="step.success.copyCouponCode" defaultMessage="Copy promo code" />
                </CopyToClipboard>
            </div>
            <div className="sid-footer sid-l-horz-left sid-l-space-top-md">
                <FormattedHTMLMessage id="step.success.emailNotification" defaultMessage={`
                    We have emailed you a copy so you can use your code now or later. Look for the email from verify@sheerid.com
                `} />
            </div>

            <div className="sid-submit sid-l-space-top-md">
                <button
                    onClick={() => redirect(redirectDestination)}
                    className="sid-btn sid-btn--dark"
                >
                    <FormattedHTMLMessage id="step.success.redirectButtonText" defaultMessage="Continue" />
                </button>
            </div>

            <FormFooter verificationService={verificationService} />
        </div>
    );
};


export const StepSuccessComponent = injectIntl(StepSuccess);

